import React from 'react'

const InputCheckFilter = ({ checked, onChange, name, text }) => {
    return (
        <li>
            <div className="flex items-center px-2 py-1 rounded hover:bg-gray-100">
                <label
                    className="w-full ml-1 text-xs font-light text-gray-900 rounded flex items-center gap-1">
                    <input
                        className="w-3.5 h-3.5 text-blue-600 bg-gray-100 border-gray-300 rounded"
                        type='checkbox'
                        name={`${name}`}
                        checked={checked}
                        onChange={onChange}
                    />
                    {text}
                </label>
            </div>
        </li>
    )
}

export default InputCheckFilter